export * from './booking-info-paragraph';